import React, { ComponentProps } from 'react'
import PriceRowLuxPlusPrice from './PriceRowLuxPlusPrice'

type InheritedPriceRowLuxPlusPriceProps = Pick<ComponentProps<typeof PriceRowLuxPlusPrice>, 'className' | 'data-testid' | 'discountPercentage' | 'discountType' | 'memberPrice' | 'saleUnit' | 'signDisplay' | 'size'>

interface Props extends InheritedPriceRowLuxPlusPriceProps {
  caption: string
}

/**
 * Displays a formatted price with a leading caption and a trailing sale unit.
 */
function PriceRowLuxPlusPriceWithCaption(props: Props) {
  const { className, ...rest } = props
  return <PriceRowLuxPlusPrice
    {...rest}
    className={className}
    logoPlacement="leading"
  />
}

export default PriceRowLuxPlusPriceWithCaption
